import * as React from 'react';
import { XIColors, XIColorUsage, XIAppIcon, XIAnimation } from '@inmoment/the-kitchen';
import { VersionUpdates, PageSection } from '../UpdatePage/PageSection/PageSection';
import { TitleText } from '../../../cookbook-ui/custom-components/TitleText/TitleText';
import { Page } from '../../../cookbook-ui/Page_SC';

import { UpdatePageWrapper, HeaderWrapper, SectionWrapper } from '../UpdatePage/UpdatePage_SC';
import { KitchenContext } from '../../../App';

const { orca } = XIColors;

export interface Updates {
  version: string;
  versionDate: string;
  versionUpdates: VersionUpdates;
}
export interface Props {}

export const UpcomingBreakingChanges: React.FC<Props> = () => {
  const { breakingChanges = [], isLoadingBreakingChanges } = React.useContext(KitchenContext);

  const sections = breakingChanges.map<JSX.Element>((updateItem, i) => {
    return (
      <PageSection key={updateItem.version} isBreaking backgroundColor={i % 2 === 0 ? orca.light[95] : XIColorUsage.silver} updateItem={updateItem} />
    );
  });

  return (
    <UpdatePageWrapper>
      <HeaderWrapper>
        <Page>
          <XIAppIcon icon="announcements" />
          <TitleText
            headerText="Upcoming Breaking Changes"
            footerText={`With our rapidly changing library, there will inevitably be some API changes until we are more stable. Here you can get ahead of the game with our projected changes, to make the library more stable & serve you better.`}
            isLargeHeader
          />
          <br />
          <br />
          <hr />
        </Page>
      </HeaderWrapper>
      <SectionWrapper>
        {isLoadingBreakingChanges ? (
          <XIAnimation animation="CUSTOMER_loader" />
        ) : breakingChanges.length ? (
          sections
        ) : (
          <p className="kxi-error kxi-text-center">
            The server providing this information is down, we are working on restoring access. Thank you for your patience.
          </p>
        )}
      </SectionWrapper>
    </UpdatePageWrapper>
  );
};
